import React, { useState } from "react"
import clsx from "clsx"

import { Icon } from "../../icon"
import { Link } from "../../link"
import { getAllButLastWord, getLastWord } from "../../../utils"

function ArrowButton({ label, href, className = "h4", onClick }) {
  const [isHovering, setIsHovering] = useState(false)

  return (
    <Link
      data-component="ArrowButton"
      className={clsx(
        "text-darkNavy focus:outline-none focus:text-violet",
        className
      )}
      href={href}
      onMouseEnter={() => setIsHovering(true)}
      onMouseLeave={() => setIsHovering(false)}
      onClick={e => onClick && onClick(e)} // TODO: "target Element not found" warning when City is clicked
    >
      {getAllButLastWord(label)}
      <span className="whitespace-nowrap inline-flex items-center flex-shrink-0">
        {getLastWord(label)}
        <span
          className="flex items-center justify-center"
          style={{
            width: "0.375em",
            height: "0.375em",
            marginTop: "0.25em",
            marginLeft: "0.25em",
          }}
        >
          <Icon
            className={clsx(
              "text-violet transform transition-transform ease-out duration-300",
              isHovering === true && "translate-x-1"
            )}
            symbol="arrow-right"
            size="0.375em"
          />
        </span>
      </span>
    </Link>
  )
}

export default ArrowButton
